/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { di } from 'react-magnetic-di';
import { getIframeSandboxAttribute } from '../../../../utils';
import { IFrame } from '../../../EmbedCard/components/IFrame';
var iframeCss = css({
  width: '100%',
  height: 'calc(100vh - 208px)'
});
var EmbedContent = function EmbedContent(_ref) {
  var isTrusted = _ref.isTrusted,
    name = _ref.name,
    src = _ref.src,
    testId = _ref.testId;
  var sandbox = getIframeSandboxAttribute(isTrusted);
  var props = {
    css: iframeCss,
    frameBorder: 0,
    name: name,
    sandbox: sandbox,
    src: src,
    'data-testid': "".concat(testId, "-embed")
  };
  return jsx(IFrame, props);
};
export default EmbedContent;